import { Component, Input, OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


import { UserService } from '../../../services/user.service';

interface MenuItem {
    icon: string;
    label: string;
    link: string;
}

@Component({
    selector: 'app-profile-menu-repost',
    templateUrl: './profile_menu_repost.component.html',
    styleUrls: ['./profile_menu_repost.component.css']
})
export class ProfileMenuRepostComponent implements OnInit, OnDestroy {
    @Input() UserID: number;
    @Input() postUserId: number;
    @Input() ProfileName: string;  // Input property to receive username    menuItems: MenuItem[];  // Array to hold menu items
    @Input() Username: string;  // Input property to receive username    menuItems: MenuItem[];  // Array to hold menu items
    @Input() PublishDate: Date;  // Input property to receive username    menuItems: MenuItem[];  // Array to hold menu items
    @Input() ImageDirectory: string;
    @Input() isFollowed: boolean;
    @ViewChild('repostLink', { static: false }) repostLinkElement: ElementRef;


    menuItems: MenuItem[];  // Array to hold menu items

    userProfileStates = new Map<number, any>();

    showProfileBox: boolean = false;
    showTooltip: boolean = false;

    userProfileVisible = false;
    hoverBoxStyle = {};
    userProfile: any;

    private unsubscribeHover$ = new Subject<void>();

    //private hoverTimer: any; // To hold the timer reference
    hoverTimer: any; // To hold the timer reference
    private timeoutId: any; // Holds the reference to the timeout

    constructor(
        private userService: UserService,
    ) {
        // Define menu items - this could instead be loaded from a service
        this.menuItems = [
            { icon: 'fa-house', label: 'Home', link: '/' },
            { icon: 'fa-compass', label: 'Explore', link: '/explore' },
            { icon: 'fa-bell', label: 'Notifications', link: '/notifications' },
            // Add more items as needed
        ];
    }

    ngOnInit(): void {
        // Additional initialization can be done here
    }

    ngOnDestroy(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Clear timeout on component destruction
        }
        if (this.hoverTimer) {
            clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
        }

    }

    @HostListener('window:scroll', ['$event'])
    onScroll(): void {
        this.showProfileBox = false;
        this.showTooltip = false;
        // Clear the timeoutId after it executes
        this.timeoutId = null;
        this.hoverTimer = null;
    }

    loadUserProfile(event: MouseEvent) {
        //console.log(`Mouse over:`);

        event.stopPropagation(); // Add this to prevent event bubbling

        // Check the class of the event target to determine which functionality to trigger
        const target = event.target as HTMLElement;
        if (target.classList.contains('publish-date')) {
            // Logic for showing the date tooltip
            this.hoverTimer = setTimeout(() => {
                //this.showTooltip = true;
            }, 1000);  // Delay in milliseconds
        } else {
            this.hoverTimer = setTimeout(() => {
                //if (!this.userProfileStates.has(index)) {
                //    this.userProfileStates.set(index, { visible: false });
                //}

                this.userService.getUserProfile(this.Username).subscribe(data => {

                    this.userProfile = data;
                    this.adjustHoverBoxPosition(event);
                    this.showProfileBox = true;
                    //console.log("this.showProfileBox : " + this.showProfileBox );
                });
            }, 1000); // Delay of 1000 milliseconds (1 second)
        }
    }

    keepHoverBoxVisible(): void {
        //this.unsubscribeHover$.next();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Cancel the pending timeout
            this.timeoutId = null;
        }
        this.showProfileBox = true;
    }

    hideUserProfile() {
        //clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
        //this.showProfileBox = false;

        //this.unsubscribeHover$.next();
        //timer(500).pipe(takeUntil(this.unsubscribeHover$)).subscribe(() => {
        //    this.showProfileBox = false; // Delay hiding the box to allow for transition
        //    //this.showTooltip = false;
        //});

        //if (this.userProfileStates.has(index)) {
        //    this.userProfileStates.get(index).visible = false;
        //}
        if (this.timeoutId) clearTimeout(this.timeoutId);
        if (this.hoverTimer) clearTimeout(this.hoverTimer);

        // Set a new timeout
        this.timeoutId = setTimeout(() => {
            //clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
            this.showProfileBox = false;
            this.showTooltip = false;
            // Clear the timeoutId after it executes
            this.timeoutId = null;
        }, 1000); // Delay in milliseconds

    }

    adjustHoverBoxPosition(event: MouseEvent): void {
        if (this.repostLinkElement && this.repostLinkElement.nativeElement) {
            const rect = this.repostLinkElement.nativeElement.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const hoverBoxHeight = 200;  // Fixed height or dynamically determined

            if (spaceBelow < hoverBoxHeight) {
                this.hoverBoxStyle = { bottom: '30px' };
            } else {
                this.hoverBoxStyle = { top: '30px' };
            }
        }
    }
    followUser() {
        this.userService.followUser(this.UserID, this.postUserId, this.isFollowed,false,false).subscribe({
            next: (result) => {
                console.log('User followed successfully');
            },
            error: (error) => {
                console.error('Error following the user', error);
            }
        });
    }

}
